// =============================================================================
// positions.js — the department's job titles (Oct 2026)
// =============================================================================
// `positions[key] = {label, rank, oncall_grade}` (src/logic/positions.py); a
// person holds at most one, as `employee.position` (a key). A position is
// DISPLAY: picking one fills in its suggested rank and on-call grade, which stay
// the person's own to change. The solver reads only the person's numbers.
// =============================================================================
import { apiFetch } from './apiClient';

/** The server's positions object as [{key, label, rank, oncallGrade, holders}],
 *  in the server's order (most senior suggested rank first). */
export function positionList(positions) {
  return Object.entries(positions || {}).map(([key, p]) => ({
    key,
    label: p?.label || key,
    rank: p?.rank ?? 4,
    oncallGrade: p?.oncall_grade ?? p?.oncallGrade ?? null,
    holders: p?.holders ?? 0,
  }));
}

export async function fetchPositions() {
  const r = await apiFetch('/api/positions');
  const d = await r.json();
  return positionList(d.positions);
}

/** A person's position key ('' for none). */
export const positionOf = (person) => person?.position || '';
